import React, { useContext } from "react";
import Inicio from "./Inicio";
import Pizza from "./Pizza";
import Promocion from "./Promocion";
import Login from "../components/admin/Login";
import ProductoPrincipal from "../components/admin/product/ProductoPrincipal";
import Administracion from "../components/admin/Administracion";
import AgregarProducto from "../components/admin/product/AgregarProducto";
import SlidePrincipal from "../components/admin/product/SlidePrincipal";
import PromocionesPrincipal from "../components/admin/product/PromocionesPrincipal";
import AgregarPromocion from "../components/admin/product/AgregarPromocion";

import ProtectedRoute from "./ProtectedRoute";
import * as firebase from "firebase";

import { Auth } from "../context/AuthContext";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";

function Header() {
  const { usuario } = useContext(Auth);

  let menu;
  if (usuario) {
    menu = (
      <ul className="navbar-nav ml-auto">
        <li className="nav-item">
          <a className="nav-link text-white" href="/admin/administrar">
            ADMINISTRACIÓN
          </a>
        </li>
        <li className="nav-item">
          <a
            className="nav-link text-white"
            href="/"
            onClick={() => firebase.auth().signOut()}
          >
            CERRAR SESIÓN
            <i className="fa fa-sign-out ml-1" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    );
  } else {
    menu = (
      <ul className="navbar-nav ml-auto">
        <li className="nav-item">
          <a className="nav-link text-white" href="/">
            INICIO
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link text-white" href="/pizza">
            PIZZAS
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link text-white" href="/promocion">
            PROMOCIONES
          </a>
        </li>
      </ul>
    );
  }

  return (
    <>
      <Router>
        <div className="bg-principal">
          <div className="container">
            <Navbar className="bg-principal" bg="light" expand="lg">
              <Navbar.Brand className="text-white" href="/">
                App
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ml-auto">{menu}</Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>

        <div className="container mb-3 mt-3" style={{ minHeight: 500 }}>
          <Switch>
            <Route exact path="/">
              <Inicio />
            </Route>
            <Route path="/pizza">
              <Pizza />
            </Route>
            <Route path="/promocion">
              <Promocion />
            </Route>
            <Route exact path="/admin" component={Login} />
            <ProtectedRoute
              exact
              path="/admin/administrar"
              component={Administracion}
            />
            <ProtectedRoute
              exact
              path="/admin/producto"
              component={ProductoPrincipal}
            />
            <ProtectedRoute
              exact
              path="/admin/producto/agregar"
              component={AgregarProducto}
            />
            <ProtectedRoute
              exact
              path="/admin/slide"
              component={SlidePrincipal}
            />
            <ProtectedRoute
              exact
              path="/admin/promocion"
              component={PromocionesPrincipal}
            />
            <ProtectedRoute
              exact
              path="/admin/promocion/agregar"
              component={AgregarPromocion}
            />
          </Switch>
        </div>

        <footer>
          <div className="container text-white">
            <div className="card-footer text-muted d-flex justify-content-center">
              Desarrollado: Gabriel Juárez Gómez
            </div>
          </div>
        </footer>
      </Router>
    </>
  );
}

export default Header;

/*
<div className="menu-mobile-principal">
    <Navbar.Brand href="/">App</Navbar.Brand>
    <div className="menu-mobile">
    <Nav.Link className="text-white mr-0 pr-0" href="/promocion">
      PROMOCIONES
    </Nav.Link>
  </div>
  <Navbar.Toggle aria-controls="basic-navbar-nav" />
</div>*/
